export default __webpack_public_path__ + "static/media/share.d891d081.svg";